WiseMetering.Views.NewWeatherAPIIntegration = WiseMetering.Views.Modal.Save.extend({
    className: 'mbx-info text-left',
    form_prefix: 'integration',
    template: 'templates/integrations/weather_api/new',
    ui: {
        sites: '#integration_site_id'
    },
    title: () => i18next.t('modal.title.integrations.new'),

    afterSave: function() {
        WiseMetering.indicators.fetch();
    },

    onShow: function() {
        const sites = WiseMetering.utils.optionsFromModels(WiseMetering.zones.sites().models);

        this.ui.sites.html(sites);
    },

    getFormData: function() {
        const data = this.formSerializer();
        data.partner_id = this.options.license.get('partner_id');
        return data;
    }
});
